import { getPathWithSearch } from './routing';

type BuildYakliTargetUrlArgs = {
  slug?: string;
  commentId?: string;
  pageId?: string;
  fullBasepathUrl?: string;
  baseHref: string;
};

/**
 * Construit l'URL cible (celle qui sera raccourcie par yakli) d'un partage de
 * commentaire ou de page.
 *
 * ⚠ basepath-prefixed-yakli-links_P1 : sur un tenant servi en sous-répertoire
 * (Next `basePath`, ex. beaute-test = `/forums`), l'ancienne branche `slug`
 * reconstruisait `/t/${slug}` en chemin ABSOLU résolu contre l'origine → le basePath
 * était perdu (URL amputée du `/forums` → 404). On repart donc du `fullBasepathUrl`
 * du tenant (host canonique + basePath, ex. `https://www.beaute-test.com/forums`,
 * déjà sans slash final), même source que les URLs canonical/JSON-LD (contrat B8_02).
 * La branche sans slug repart de `baseHref` (= `window.location`, déjà porteur du
 * basePath) : `fullBasepathUrl` n'y est pas utilisé.
 */
export function buildYakliTargetUrl({
  slug,
  commentId,
  pageId,
  fullBasepathUrl = '',
  baseHref,
}: BuildYakliTargetUrlArgs): string {
  const href = slug ? `${fullBasepathUrl}/t/${slug}` : baseHref;

  return getPathWithSearch({
    path: href,
    params: commentId
      ? { yakli: commentId, yakli_type: 'comment' }
      : { yakli: pageId, yakli_type: 'page' },
  });
}
